import { render, staticRenderFns } from "./SendTextinvites.vue?vue&type=template&id=ff2e6812&"
import script from "./SendTextinvites.vue?vue&type=script&lang=js&"
export * from "./SendTextinvites.vue?vue&type=script&lang=js&"
import style0 from "./SendTextinvites.vue?vue&type=style&index=0&id=ff2e6812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports